<app-header class="header"></app-header>

<ion-content scrollbar>
  <app-loading-sti *ngIf="loading"></app-loading-sti>
  <div *ngIf="!p.renderMobile" class="breadcrumb-margin">
    <app-breadcrumb></app-breadcrumb>
  </div>

  <ng-container *ngIf="!isError; else HTTPError">
    <ion-grid *ngIf="!loading">
      <ion-grid class="edit-invitation__details-container">
        <ion-row>
          <ion-col size="12" size-md="8" class="edit-invitation__details">
            <div
              class="display-flex ion-align-items-center ion-margin-bottom"
              *ngIf="!p.renderMobile"
            >
              <h2 class="edit-invitation__title">
                {{invitationServ.invitation.title}}
              </h2>
              <ion-button
                *appHasRole="['invitation.delete']"
                (click)="onDeleteInvitation()"
                fill="clear"
              >
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            </div>
            <p>{{invitationServ.invitation.description}}</p>
            <ion-grid class="margin-minus-10">
              <ion-row>
                <ion-col
                  size-xs="12"
                  size-sm="6"
                  class="edit-invitation__single-detail-container--first"
                >
                  <span class="edit-invitation__small-label">
                    {{ "INVITATION.TERM" | translate }}
                  </span>
                  <div class="edit-invitation__single-detail-container">
                    <ion-icon
                      slot="start"
                      class="edit-invitation__single-detail-icon"
                      src="../../../../assets/icons/calendar.svg"
                    ></ion-icon>
                    <div>
                      <div class="edit-invitation__single-detail-title">
                        {{invitationServ.invitation.dateStart | date: 'cccc' :
                        "" : translateService.currentLang}},
                        {{invitationServ.invitation.dateStart | dateSti:
                        'onlyDate'}}
                      </div>
                      <div class="edit-invitation__single-detail-subtitle">
                        {{invitationServ.invitation.dateStart | dateSti:
                        'onlyHour'}} - {{invitationServ.invitation.dateEnd |
                        dateSti: 'onlyHour'}}
                      </div>
                    </div>
                  </div>
                </ion-col>
                <ion-col
                  size-xs="12"
                  size-sm="6"
                  class="edit-invitation__single-detail-container--second"
                >
                  <span class="edit-invitation__small-label">
                    {{ "INVITATION.PLACE" | translate }}
                  </span>
                  <div class="edit-invitation__single-detail-container">
                    <ion-icon
                      slot="start"
                      class="edit-invitation__single-detail-icon"
                      src="../../../../assets/icons/building-alt.svg"
                    ></ion-icon>
                    <div>
                      <div class="edit-invitation__single-detail-title">
                        {{ buildingSelected? buildingSelected.name : (
                        "BUILDING_MISSING" | translate ) }}
                      </div>
                      <div class="edit-invitation__single-detail-subtitle">
                        {{invitationServ.invitation.adress.split(',')[1]}}
                        {{invitationServ.invitation.adress.split(',')[2]}}
                      </div>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
          <ion-col class="edit-invitation__host" size="12" size-md="4">
            <div class="edit-invitation__host-header-container">
              <div>
                <div class="edit-invitation__host-header">
                  {{ "INVITATION.ORGANIZER" | translate }}
                </div>
                <div class="edit-invitation__host-name">
                  {{invitationServ.invitation.user.firstName }}
                  {{invitationServ.invitation.user?.lastName}}
                </div>
              </div>
              <app-avatar
                *ngIf="invitationServ.invitation.user.firstName"
                [big]="true"
                [user]="invitationServ.invitation.user"
              >
              </app-avatar>
            </div>

            <div>
              <div class="element_icon-text">
                <ion-icon
                  src="../../../../assets/icons/mail.svg"
                  size="small"
                  class="edit-invitation__host-icon"
                ></ion-icon>
                <span>{{ invitationServ.invitation.user.email }}</span>
              </div>
              <div
                class="element_icon-text"
                *ngIf="invitationServ.invitation.user.mobilePhone"
              >
                <ion-icon
                  name="phone-portrait-outline"
                  size="small"
                  class="edit-invitation__host-icon"
                ></ion-icon>
                <span>{{ invitationServ.invitation.user.mobilePhone }}</span>
              </div>
              <div
                class="element_icon-text"
                *ngIf="invitationServ.invitation.user.telephone"
              >
                <ion-icon
                  src="../../../../assets/icons/phone.svg"
                  class="edit-invitation__host-icon"
                  size="small"
                ></ion-icon>
                <span>{{ invitationServ.invitation.user.telephone }}</span>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>

      <h2 class="edit-invitation__subheader">
        {{'INVITATION.INVITATION_GUESTS' | translate}}
      </h2>

      <ion-grid>
        <ion-row class="edit-invitation__guest-row" *ngIf="!refreshGuestCard">
          <ion-col
            size-xl="4"
            size-lg="6"
            size-md="6"
            size-sm="12"
            *ngFor="let guest of invitationServ.invitation.invitationGuests"
            class="edit-invitation__guest-column"
          >
            <div class="edit-invitation__guest-container">
              <div class="display-flex ion-justify-content-between">
                <div>
                  <h3 class="edit-invitation__guest-header">
                    {{ guest.fullname }}
                  </h3>
                  <div class="element_icon-text">
                    <div class="edit-invitation__guest-email--icon">
                      <ion-icon
                        name="mail-outline"
                        class="edit-invitation__guest-icon"
                      ></ion-icon>
                    </div>
                    <div class="edit-invitation__guest-email--text">
                      <span>{{ guest.email }} </span>
                    </div>
                  </div>
                  <div class="element_icon-text">
                    <ion-icon
                      src="../../../../assets/icons/phone.svg"
                      class="edit-invitation__guest-icon"
                    ></ion-icon>
                    <span>{{ guest.phoneNumber ?? '- - -' }} </span>
                  </div>
                  <div class="element_icon-text">
                    <ion-icon
                      src="../../../../assets/icons/parking-icon.svg"
                      class="edit-invitation__guest-icon"
                    ></ion-icon>
                    <span>
                      {{ guest.carPlate ?? '- - -' }} 
                      {{ guest.carSpaceNumber ? ' - ' + guest.carSpaceNumber : '' }}
                    </span>
                  </div>

                  <div class="element_icon-text">
                    <ion-icon
                      src="../../../../assets/icons/card.svg"
                      class="edit-invitation__guest-icon"
                    ></ion-icon>
                    <span>{{ guest.accessCard || '- - -' }} </span>
                  </div>
                </div>
                <div>
                  <div
                    class="options-button"
                    size="small"
                    (click)="presentPopover($event, guest)"
                  >
                    <ion-icon
                      slot="icon-only"
                      name="ellipsis-horizontal"
                    ></ion-icon>
                  </div>
                </div>
              </div>

              <ion-grid class="no-padding-grid booking-mobile">
                <ion-row>
                  <ion-col class="edit-invitation__mobile-dates-label">
                    <span *ngIf="guest.entryDate">
                      {{ 'ADD_INVITATION.TEXT_ARRIVAL' | translate}}
                    </span>
                    <span *ngIf="guest.leaveDate">
                      {{ 'ADD_INVITATION.TEXT_EXIT' | translate}}
                    </span>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="guest.entryDate">
                  <ion-col
                    *appHasRole="['invitation.guest-timeline']"
                    class="display-flex ion-align-items-center ion-justify-content-between"
                  >
                    <div
                      class="edit-invitation__mobile-dot edit-invitation__mobile-dot--start"
                    ></div>
                    <div class="edit-invitation__mobile-separator"></div>
                    <div
                      class="edit-invitation__mobile-dot edit-invitation__mobile-dot--end"
                    ></div>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="edit-invitation__mobile-dates-container">
                    <ng-container *ngIf="!guest.entryDate">
                      <ion-button
                        *appHasRole="['invitation.confirm-arrival']"
                        (click)="onGuestEnterLeave(guest)"
                        [disabled]="onGuestButtonClicked"
                      >
                        <ion-label
                          >{{ 'ADD_INVITATION.CONFIRM_ARRIVAL' |
                          translate}}</ion-label
                        >
                      </ion-button>
                    </ng-container>
                    <span *ngIf="guest.entryDate">
                      {{ guest.entryDate | dateSti }}
                    </span>

                    <ng-container *ngIf="guest.entryDate && !guest.leaveDate">
                      <ion-button
                        *appHasRole="['invitation.confirm-exit']"
                        (click)="onGuestEnterLeave(guest)"
                        [disabled]="onGuestButtonClicked"
                      >
                        <ion-label
                          >{{ 'ADD_INVITATION.CONFIRM_EXIT' |
                          translate}}</ion-label
                        >
                      </ion-button>
                    </ng-container>
                    <span *ngIf="guest.leaveDate">
                      {{ guest.leaveDate | dateSti }}
                    </span>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="refreshGuestCard">
          <app-loading-sti class="w-100"></app-loading-sti>
        </ion-row>
      </ion-grid>

      <h2 
        *ngIf="invitationServ.invitation.invitationEmployees?.length > 0" 
        class="edit-invitation__subheader"
      >
        {{'INVITATION.INVITATION_EMPLOYEES' | translate}}
      </h2>

      <ion-grid *ngIf="invitationServ.invitation.invitationEmployees?.length > 0">
        <ion-row class="edit-invitation__guest-row">
          <ion-col
            size-xl="4"
            size-lg="6"
            size-md="6"
            size-sm="12"
            *ngFor="let employee of invitationServ.invitation.invitationEmployees"
            class="edit-invitation__guest-column"
          >
            <div class="edit-invitation__guest-container">
              <div class="display-flex ion-justify-content-between">
                <div class="edit-invitation__image__employee-container">
                  <h3 class="edit-invitation__guest-header">
                    {{ employee.firstName + ' ' + employee.lastName }}
                  </h3>
                  <div class="element_icon-text">
                    <div class="edit-invitation__guest-email--icon">
                      <ion-icon
                        name="mail-outline"
                        class="edit-invitation__guest-icon"
                      ></ion-icon>
                    </div>
                    <div class="edit-invitation__guest-email--text">
                      <span>{{ employee.email }} </span>
                    </div>
                  </div>
                  <div class="element_icon-text">
                    <ion-icon
                      src="../../../../assets/icons/phone.svg"
                      class="edit-invitation__guest-icon"
                    ></ion-icon>
                    <span>{{ employee.mobilePhone || '- - -' }} </span>
                  </div>
                  <div class="element_icon-text">
                    <ion-icon
                      src="../../../../assets/icons/parking-icon.svg"
                      class="edit-invitation__guest-icon"
                    ></ion-icon>
                    <span>
                      {{ employee.carPlate || '- - -' }}
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ng-container
        *ngIf="invitationSpace"
      >
        <h2 class="edit-invitation__subheader">
          {{'ADD_INVITATION.BOOKED_ROOMS' | translate}}
        </h2>

        <ion-grid *ngIf="!p.renderMobile && !invitationSpaceLoading">
          <ion-row class="edit-invitation__space-container">
            <ion-col size-lg="2">
              <img
                *ngIf="invitationSpace.image"
                class="edit-invitation__image"
                (click)="
                onImagePreview($event, invitationSpace.image.filePath)
              "
                [src]="
              invitationSpace.image.thumbnail
                  ? invitationSpace.image.thumbnail
                  : invitationSpace.image.filePath
              "
              />

              <img
                *ngIf="!invitationSpace.image"
                class="edit-invitation__image edit-invitation__image--plug"
                src="../../../assets/icons/room-plug.svg"
              />
            </ion-col>
            <ion-col size="2" class="bold"> {{invitationSpace.name}} </ion-col>
            <ion-col size="2" class="display-flex ion-align-items-center">
              <ion-icon
                class="edit-invitation__single-detail-icon"
                src="../../../../assets/icons/building-alt.svg"
              ></ion-icon>
              {{ invitationSpace.floor.building.name }}
            </ion-col>
            <ion-col size="2">
              <ion-icon
                name="code"
                class="add-invitation-space-view__icon rotate-90-deg"
              ></ion-icon>
              {{ invitationSpace.floor.name }} ({{invitationSpace.floor.level}})
            </ion-col>
            <ion-col size="4">
              <div
                class="ion-no-padding add-invitation-space-view__detail"
                *ngIf="invitationSpace.equipments.length > 0"
              >
                <div
                  class="options-button"
                  size="small"
                  (click)="showEquipmentsList($event)"
                >
                  <ion-icon slot="icon-only" name="star-outline"></ion-icon>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
        <ng-container *ngIf="p.renderMobile && !invitationSpaceLoading">
          <app-add-invitation-space-view
            [row]="invitationSpace"
            customData="no-border"
          >
          </app-add-invitation-space-view>
        </ng-container>
      </ng-container>
    </ion-grid>
  </ng-container>
  <ng-template #HTTPError>
    <app-api-not-found
      name="ADD_INVITATION.INVITATION"
      returnText="ADD_INVITATION.RETURN_TO_VIRTUAL_RECEPTION"
      link="app/invitation"
      [status]="errorStatusCode"
    >
    </app-api-not-found>
  </ng-template>
</ion-content>

<div class="badge-container">
  <div class="row">
    <div class="guest">
      <span>Guest</span>
    </div>
    <div class="fullname">
      <span>{{guestToPrint ? guestToPrint.fullname : ''}}</span>
    </div>
  </div>
  <div *ngIf="guestToPrint" class="qrcode">
    <qrcode
      [qrdata]="guestToPrint ? guestToPrint.qrcode.qrcodeValue : ''"
      [width]="150"
      [errorCorrectionLevel]="'M'"
    >
    </qrcode>
  </div>
</div>
